// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";
import { SavedSpellAspect } from "src/api/spells";

const metadata: BuiltInScriptMetadata = {
  name: "Fireball",
  id: "fireball",
  metadata: {
    aspect: SavedSpellAspect.Fire,
    imports: ["fire"],
    icon: {
      "backgroundColor": 3286293,
      "layers": [
        {
          "iconKey": "fireball",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": -9,
          "color": 16755792
        }
      ]
    },
  },
};

export default metadata;
